module.exports = __webpack_public_path__ + "img/upsell-companion.bc4577c8.svg";